export default __webpack_public_path__ + "static/media/stars.6475a879.webp";